const en = {
  "links.CLI_repository": "https://cli.nestle.platform.sh",
  "setup.cli.instal.code":
    "curl -sfS https://cli.nestle.platform.sh/installer | php",
  "setup.cli.instal.label": "Install CLI"
};

export default en;
